export const openDropdown = () => {
    
    const dropdowns = document.querySelectorAll('[vdx-dropdown-open]');
    
    if (dropdowns.length === 0) return; 

    // Initially open the dropdowns with vdx-dropdown-open attribute
    dropdowns.forEach(dropdown => {
        // Check if attribute has a value to determine which child to open
        const openIndex = dropdown.getAttribute('vdx-dropdown-open');
        // Default to first child if no value or invalid value
        const childIndex = openIndex && !isNaN(parseInt(openIndex)) ? parseInt(openIndex) - 1 : 0;
        
        // Get the target child element of the dropdown
        const children = dropdown.children;
        if (!children || childIndex >= children.length) return;
        
        const targetChild = children[childIndex];
        const toggleButton = targetChild.querySelector('.w-dropdown-toggle');
        
        // Apply classes and attributes to the target child
        if (targetChild && toggleButton) {
            toggleButton.classList.add('w--open');
            
            setTimeout(() => {
                toggleButton.setAttribute('aria-expanded', 'true');
            }, 0);
            
            // Also handle the dropdown list for compatibility
            const dropdownList = targetChild.querySelector('.w-dropdown-list');
            if (dropdownList) {
                dropdownList.classList.add('w--open');
            }
        }
        
        dropdown.addEventListener('click', () => {
            dropdown.querySelectorAll('.w-dropdown-toggle').forEach(toggle => {
                toggle.classList.remove('w--open');
                toggle.setAttribute('aria-expanded', 'false');
            });
            dropdown.querySelectorAll('.w-dropdown-list').forEach(list => {
                list.classList.remove('w--open');
            });
        });
    });
}